import { useQuery, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../../types/API';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { AdvisoryReport } from '../types/AdvisoryReport';

export const getAdvisoryReportById = async (reportId: string) => {
  const { data, isError } = await wgApi.get<AdvisoryReport | ErrorResponse>(
    `v1/api/advisory-reports/${reportId}`,
  );
  if (isError) throw new Error((data as ErrorResponse).code?.toString());
  return data as AdvisoryReport;
};

export const getUseAdvisoryReportQKey = (advisoryReportId: string) => [
  'advisory-report',
  'detail',
  advisoryReportId,
];

interface QueryOptions {
  refetchOnMount: boolean;
}

export const useAdvisoryReport = (
  advisoryReportId: string,
  queryOptions?: QueryOptions,
): UseQueryResult<AdvisoryReport> => {
  return useQuery(
    getUseAdvisoryReportQKey(advisoryReportId),
    () => getAdvisoryReportById(advisoryReportId),
    {
      enabled: !!advisoryReportId,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: (retryCount, error) => {
        /** Stop retrying when errorcode is 404 or retryCount is more than 3 */
        if ((error as Error).message === '404' || retryCount > 3) return false;
        return true;
      },
      ...queryOptions,
    },
  );
};
